<template>
  <section class="hp-section hp-visume hp-animate hp-animate--delay-2">
    <div class="hp-visume__glow" aria-hidden="true"></div>
    <div class="container">
      <div class="hp-visume__grid">
        <div class="hp-visume__copy">
          <p class="hp-visume__eyebrow">Your face is the best interface</p>
          <h2 class="hp-visume__title">Post your 2-min video profile <span>#visume</span></h2>
          <p class="hp-visume__lead">
            Impress recruiters with a short video intro — showcase your personality, skills, and why a company should hire you.
          </p>
          <ol class="hp-visume__steps">
            <li v-for="(step, i) in steps" :key="i">
              <span class="hp-visume__step-num">{{ i + 1 }}</span>
              <div>
                <strong>{{ step.title }}</strong>
                <p>{{ step.text }}</p>
              </div>
            </li>
          </ol>
          <a href="/jobseeker/register" class="hp-btn hp-btn--light hp-visume__cta">Post your visume — it's free</a>
        </div>
        <div class="hp-visume__media">
          <video
            class="hp-visume__video"
            :poster="$S3_url + '/Assets/images/maxresdefault.jpg'"
            controls
            preload="none"
          >
            <source :src="$S3_url + '/Assets/videos/hireclap-hire-matching-candidates.mp4'" type="video/mp4" />
          </video>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'HomeVisumeSection',
  data() {
    return {
      steps: [
        { title: 'Record a 2-min intro', text: 'Show your skills, experience, and personality on camera.' },
        { title: 'Get matched to jobs', text: 'Recruiters discover your profile across fresher and entry-level roles.' },
        { title: 'Stand out from the crowd', text: 'Candidates with a visume see up to 40% higher shortlist rates.' },
      ],
    };
  },
};
</script>
